import { Injectable } from '@angular/core';
import { Defaultconfig } from '../shared/models/Defaultconfig';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CookieStore } from '../shared/helpers/CookieStore';
import { Title } from '@angular/platform-browser';
import { CommunicationService } from './communication.service';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthService {
  // constructor(private http: HttpClient, private titleService: Title, private communicationService: CommunicationService) { }

  // private headers: HttpHeaders = new HttpHeaders().set('Authorization', `${'Bearer ' + localStorage.getItem('access_token')}`);

  // private accessToken?: string;

  // // Method to set the access token
  // setAccessToken(token: string) {
  //   this.accessToken = token;
  // }

  // // Method to get the access token
  // getAccessToken(): string | undefined {
  //   return this.accessToken;
  // }
  constructor(
  private http: HttpClient, 
  private titleService: Title, 
  private communicationService: CommunicationService
) {
  // Subscribe once in constructor
  this.communicationService.queryParams$.subscribe((data: any) => {
    const token = data?.access_token;
    if (token) {
      localStorage.setItem('access_token', token);
    }
  });
}
 private accessToken?: string;

  // Method to set the access token
  setAccessToken(token: string) {
    this.accessToken = token;
  }

  // Method to get the access token
  getAccessToken(): string | undefined {
    return this.accessToken;
  }

  // private addCommonQueryToUrl(url: string): string {
  //   const macRef = localStorage.getItem('x_t_nbd_ref');
  //   return macRef ? `${url}?x_t_nbd_ref=${macRef}` : url;
  // }

  // private getHeaders(): HttpHeaders {
  //   let headers = new HttpHeaders();
  //   const macRef = localStorage.getItem('x_t_nbd_ref');
  //   let bearerToken = CookieStore.getBearerToken() || localStorage.getItem('access_token') || '';
  //   // Remove any accidental "Bearer " prefix from stored token
  //    bearerToken = bearerToken.replace(/^Bearer\s+/i, '');

  //   this.communicationService.queryParams$.subscribe((data: any) => {
  //     const token = data?.access_token || '';
  //     localStorage.setItem('access_token', token);
  //   });

  //   // Only add Authorization header if a token exists
  //   if (bearerToken) {
  //     headers = headers.set('Authorization', `Bearer ${bearerToken}`);
  //   }

  //   if (macRef) {
  //     headers = headers.set('x-t-nbd-ref', macRef);
  //   }
  //   return headers;
  // }
  private getHeaders(): HttpHeaders {
  let headers = new HttpHeaders();
  const macRef = localStorage.getItem('x_t_nbd_ref');
  let bearerToken = CookieStore.getBearerToken() || localStorage.getItem('access_token') || '';
  
  // Remove any accidental "Bearer " prefix from stored token
  bearerToken = bearerToken.replace(/^Bearer\s+/i, '');

  if (bearerToken) {
    headers = headers.set('Authorization', `Bearer ${bearerToken}`);
  }

  if (macRef) {
    headers = headers.set('x-t-nbd-ref', macRef);
  }
  
  return headers;
}

  private getHeadersWithToken(access_token: string): HttpHeaders {
    const macRef = localStorage.getItem('x_t_nbd_ref');
    
    // Set the Authorization header with the provided token
    let headers = new HttpHeaders().set('Authorization', `Bearer ${access_token}`);
    
    // Add custom header if available in localStorage
    if (macRef) {
      headers = headers.set('x-t-nbd-ref', macRef);
    }
    
    return headers;
  }
  

  getDynamicTitle() {
    return 'current title :' + this.titleService.getTitle();
  }

  setDynamicTitle(title: string) {
    this.titleService.setTitle(title);
  }

  getPublicLoginInfo(requestId: string): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'public-srv/login/settings/by/requestid/' + requestId;
    return this.http.post(url, {}, { headers: this.getHeaders() });
  }

  // Legacy v1 login (login-srv/login) — unused; the app logs in via login-srv/v2/login. Disabled.
  // loginWithEncCreds(data: any): Observable<any> {
  //   const url = Defaultconfig.GetAuthBaseURL() + 'login-srv/login';
  //   return this.http.post(url, data);
  // }

  initiateForgetPassword(payload: any): Promise<any> {
    const url = Defaultconfig.GetAuthBaseURL() + Defaultconfig.VERIFICATION_SRV + 'user/initiate';
    return this.http.post(url, payload, { headers: this.getHeaders() }).toPromise();
  }

  resetPasssword(payload: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + Defaultconfig.VERIFICATION_SRV + 'user/data/reset';
    return this.http.post(url, payload, { headers: this.getHeaders() });
  }

  resetVerificationCode(payload: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + Defaultconfig.VERIFICATION_SRV + 'user/verification';
    return this.http.post(url, payload, { headers: this.getHeaders() });
  }

  getRegistrationFields(requestId: string, sub?: string, resetRequestId?: string): Observable<any> {
    let url = Defaultconfig.GetAuthBaseURL() + 'public-srv/registration/settings/by/requestid/' + requestId;
    const params: string[] = [];
    if (sub) {
      params.push('sub=' + encodeURIComponent(sub));
    }
    if (resetRequestId) {
      params.push('reset_request_id=' + encodeURIComponent(resetRequestId));
    }
    if (params.length > 0) {
      url += '?' + params.join('&');
    }
    return this.http.post(url, {}, { headers: this.getHeaders() });
  }

  register(registrationDetails: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'users-srv/users/register';
    return this.http.post(url, registrationDetails);
  }

  registerv2(registrationDetails: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'users-srv/v2/users/register';
    return this.http.post(url, registrationDetails, { headers: this.getHeaders() });
  }

  registerv2Progressive(registrationDetails: any, track_id: string): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'users-srv/v2/users/register?track_id=' + `${track_id}`;
    return this.http.post(url, registrationDetails, { headers: this.getHeaders() });
  }

  resetPassword(payload: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'users-srv/users/changepassword';
    return this.http.post(url, payload, { headers: this.getHeaders() });
  }

  getnvitedUserInfo(trackId: string): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'users-srv/users/invite/info/public/' + trackId;
    return this.http.get(url, { headers: this.getHeaders() });
  }

  /**
   * Binds a device-qualified local account name (<shortname>_<hostname>) to the
   * signed-in user, for the desktop MFA agents. The access token is obtained by
   * the /bind-device page's own OIDC (auth-code + PKCE) flow and passed here
   * explicitly, so it uses getHeadersWithToken rather than the ambient headers.
   */
  bindUsername(value: string, accessToken: string, deviceLabel?: string): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'users-srv/v2/users/self/bind-username';
    const body: any = { value };
    if (deviceLabel) { body.device_label = deviceLabel; }
    return this.http.post(url, body, { headers: this.getHeadersWithToken(accessToken) });
  }

  //Breach Passwrod check call
  breachPasswordCheck(payload: any) {
    const url = Defaultconfig.GetAuthBaseURL() + 'public-srv/registration/password/breach/check';
    return this.http.post(url , payload, { headers: this.getHeaders() });
  }
  
  MFAVerifiedList(pay: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-srv/v2/verification/setup/verified/list';
    return this.http.post(url, pay, { headers: this.getHeaders() });
  }

  MFAUnVerifiedList(pay: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-public-srv/v2/verification/setup/unverified/list';
    return this.http.post(url, pay, { headers: this.getHeaders() });
  }
  MFAUnVerifiedWithTokenList(token: string, pay: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + `verification-srv/v2/verification/setup/unverified/list?access_token=${token}`;
    const headers = this.getHeadersWithToken(token);
    return this.http.post(url, pay, { headers: headers });
  }

  MFAEnabledListByAdmin(): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-srv/v2/verification';
    return this.http.get(url, { headers: this.getHeaders() });
  }

  getUserInfo(): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'users-srv/userinfo';
    return this.http.post(url, {}, { headers: this.getHeaders() });
  }

  getRegField(): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'registrationfields-srv/fields/util/enabled/list';
    return this.http.get(url, { headers: this.getHeaders() });
  }

  updateUserInfo(payload: any, sub: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'users-srv/users/update/' + sub;
    return this.http.put(url, payload, { headers: this.getHeaders() });
  }

  getBackupCode(sub: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-srv/v2/verification/setup/user-backup-code?sub=' + sub;
    return this.http.get(url, { headers: this.getHeaders() });
  }

  // Regenerate the caller's own backup codes (show-once). Requires step-up: pass { password } or
  // { track_id } from a completed email/OTP verification. Target user is derived from the token.
  // Payloads may be encrypted: { enc_key, enc_password } (see PayloadCrypto); response may be { enc_backup_codes }.
  regenerateBackupCode(payload: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-srv/v2/verification/setup/user-backup-code/regenerate';
    return this.http.post(url, payload, { headers: this.getHeaders() });
  }

  // Public key (SPKI PEM) used to wrap the AES key for backup-code payload encryption.
  getBackupCodeEncPublicKey(): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-srv/v2/verification/setup/backup-code/enc-public-key';
    return this.http.get(url, { headers: this.getHeaders() });
  }

  // Consume a secure admin-generated backup-code download link. The token (from the emailed URL) is sent in
  // the body and authorizes retrieval; no login required. Optionally pass enc_key for encrypted-in-transit
  // codes. Single-use + time-limited server-side.
  downloadBackupCodes(payload: { token: string, enc_key?: string }): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-srv/v2/verification/setup/backup-code/download';
    return this.http.post(url, payload, { headers: this.getHeaders() });
  }

  // Send an email OTP for backup-code regeneration step-up. Returns { track_id, usage_id, verification_usage_id }.
  initiateBackupCodeStepUpEmail(): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-srv/v2/verification/setup/backup-code/step-up/email/initiate';
    return this.http.post(url, {}, { headers: this.getHeaders() });
  }

  deleteMfaType(userVerificationSetupId: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-srv/v2/verification/deleteUserVerificationSetupById/' + userVerificationSetupId;
    return this.http.delete(url, { headers: this.getHeaders() });
  }

  revokeAllToken(sub: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'token-srv/revokealltoken/' + sub;
    return this.http.get(url, { headers: this.getHeaders() });
  }

  getIdsForLogout(token: any, filterType: string = 'usage'): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + `public-srv/registration/provider/settings/by/token?filter_type=${filterType}`;
    return this.http.post(url, {}, { headers: this.getHeadersWithToken(token) });
  }

  logoutv2(saved_token: any, post_logout_redirect_uri: any): void {
    const logout_base_url = Defaultconfig.GetAuthBaseURL() + 'token-srv/end_session';
    window.location.href =
      logout_base_url + '?post_logout_redirect_uri=' + post_logout_redirect_uri + '&access_token_hint=' + saved_token;
  }

  logout(token: any, post_url: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'token-srv/end_session?access_token_hint=' + token + '&post_logout_redirect_uri=' + post_url;
    return this.http.get(url, { headers: this.getHeaders() });
  }

  getConsentDetails(track_id: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'public-srv/precheck/' + `${track_id}`;
    return this.http.post(url, {}, { headers: this.getHeaders() });
  }

  acceptConsent(payload: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'public-srv/consent/usage/accept';
    return this.http.post(url, payload, { headers: this.getHeaders() });
  }

  consentContinue(track_id: any): Observable<any> {
    const headers = new HttpHeaders().set('Authorization', CookieStore.getBearerToken());
    const url = Defaultconfig.GetAuthBaseURL() + 'login-srv/continue/' + `${track_id}`;
    return this.http.post(url, {}, { headers });
  }

  verifyStatus(track_id: any): Promise<any> {
    const url = Defaultconfig.GetAuthBaseURL() + `verification-srv/v2/verification/usage/status/${track_id}`;
    return this.http.post(url, {}, { headers: this.getHeaders() }).toPromise();
  }

  verifiedList(payload: any): Promise<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-srv/v2/verification/setup/verified/list';
    return this.http.post(url, payload, { headers: this.getHeaders() }).toPromise();
  }

  initiateOTP(payload: any): Promise<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-srv/v2/verification/usage/initiate';
    return this.http.post(url, payload, { headers: this.getHeaders() }).toPromise();
  }

  validateOTP(payload: any): Promise<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-srv/v2/verification/usage/validate/otp';
    return this.http.post(url, payload, { headers: this.getHeaders() }).toPromise();
  }

  // MFA APIs
  reinitiateOTP(payload: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-srv/v2/verification/setup/reinitiate';
    return this.http.post(url, payload, { headers: this.getHeaders() });
  }

  reinitiateUsageOTP(payload: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-srv/v2/verification/usage/reinitiate';
    return this.http.post(url, payload, { headers: this.getHeaders() });
  }

  initiateMFA(payload: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-srv/v2/verification/setup/initiate';
    return this.http.post(url, payload, { headers: this.getHeaders() });
  }

  initiateMandatoryMFA(payload: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-public-srv/v2/verification/setup/initiate';
    return this.http.post(url, payload, { headers: this.getHeaders() });
  }
  initiateMandatoryMFAWithToken(token: string, payload: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-srv/v2/verification/setup/initiate';
    const headers = this.getHeadersWithToken(token);
    return this.http.post(url, payload, { headers: headers });
  }

  verifyOtpV2(payload: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-public-srv/v2/verification/setup/validate/otp';
    return this.http.post(url, payload, { headers: this.getHeaders() });
  }

  getMfaStatus(verification_usage_id: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-srv/v2/verification/setup/mfastatus/' + verification_usage_id;
    return this.http.post(url, {}, { headers: this.getHeaders() });
  }

  verifyOtp(payload: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-srv/v2/verification/setup/validate/otp';
    return this.http.post(url, payload, { headers: this.getHeaders() });
  }
  configureFido(payload: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-public-srv/v2/verification/setup/initiate/fido';
    return this.http.post(url, payload, { headers: this.getHeaders() });
  }

  // User recent activity
  userRecentActivity(payload: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'reports-v2-srv/user-reports/util/useractivity';
    return this.http.post(url, payload, { headers: this.getHeaders() });
  }

  getProgressiveRegisterInformation(track_id: string): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'public-srv/precheck/' + `${track_id}`;
    return this.http.post(url, {}, { headers: this.getHeaders() });
  }

  progressiveRegister(payload: any, track_id: string): Observable<any> {
    const headers = new HttpHeaders().set('Authorization', CookieStore.getBearerToken());
    const url = Defaultconfig.GetAuthBaseURL() + 'users-srv/users/register?track_id=' + `${track_id}`;
    return this.http.post(url, payload, { headers });
  }

  getSocialRegisterInformation(social_track_id: string): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'social-login-srv/userinfo/' + `${social_track_id}`;
    return this.http.post(url, {}, { headers: this.getHeaders() });
  }

  socialRegister(payload: any): Promise<any> {
    const headers = new HttpHeaders().set('Authorization', CookieStore.getBearerToken());
    const url = Defaultconfig.GetAuthBaseURL() + 'users-srv/users/social/register';
    return this.http.post(url, payload, { headers }).toPromise();
  }

  federationLogin(payload: any, reqest_id: any): Observable<any> {
    const headers = new HttpHeaders().set('Authorization', CookieStore.getBearerToken());
    const url = Defaultconfig.GetAuthBaseURL() + 'public-srv/login/federation/' + reqest_id;
    return this.http.post(url, payload, { headers });
  }

  // FIDO APIs
  initiateFidoSetup(payload: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-srv/v2/verification/setup/initiate';
    return this.http.post(url, payload, { headers: this.getHeaders() });
  }

  initiateFidoSetupv2(payload: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-public-srv/v2/verification/setup/initiate';
    return this.http.post(url, payload, { headers: this.getHeaders() });
  }

  registerFidoSetup(payload: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-srv/v2/verification/setup/validate/otp';
    return this.http.post(url, payload, { headers: this.getHeaders() });
  }

  registerFidoSetupv2(payload: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-public-srv/v2/verification/setup/validate/otp';
    return this.http.post(url, payload, { headers: this.getHeaders() });
  }

  initiateFidoUsage(payload: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-srv/v2/verification/usage/initiate';
    return this.http.post(url, payload, { headers: this.getHeaders() });
  }

  registerFidoUsage(payload: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-srv/v2/verification/usage/validate/otp';
    return this.http.post(url, payload, { headers: this.getHeaders() });
  }

  getUsersDeviceDetails(): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-srv/v2/verification/fido';
    return this.http.get(url, { headers: this.getHeaders() });
  }

  deleteFidoDevice(device_id: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-srv/v2/verification/fido/' + device_id;
    return this.http.delete(url, { headers: this.getHeaders() });
  }

  // Initiate webcam face recognition
  initiateFaceMFA(payload: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'mfa-srv/register/initate';
    return this.http.post(url, payload, { headers: this.getHeaders() });
  }

  // Upload face
  uploadFace(formData: any, verification_usage_id: any, usage_id: any): Observable<any> {
    const headers = new HttpHeaders().set('Authorization', CookieStore.getBearerToken());
    headers.append('content-type', 'multipart/form-data');
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-srv/v2/verification/setup/validate/face?verification_usage_id=' + `${verification_usage_id}` + '&usage_id=' + `${usage_id}`;
    return this.http.post(url, formData, { headers });
  }
  
  uploadFaceV2(formData: any, verification_usage_id: any, usage_id: any): Observable<any> {
    const headers = new HttpHeaders().set('Authorization', CookieStore.getBearerToken());
    headers.append('content-type', 'multipart/form-data');
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-public-srv/v2/verification/setup/validate/face?verification_usage_id=' + `${verification_usage_id}` + '&usage_id=' + `${usage_id}`;
    return this.http.post(url, formData, { headers });
  }
  verifyFace(formData: any, verification_usage_id: any, usage_id: any): Observable<any> {
    const headers = new HttpHeaders().set('Authorization', CookieStore.getBearerToken());
    headers.append('content-type', 'multipart/form-data');
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-srv/v2/verification/usage/validate/face?verification_usage_id=' + `${verification_usage_id}` + '&usage_id=' + `${usage_id}`;
    return this.http.post(url, formData, { headers });
  }
  
  // Scope user consent
  acceptScopeConsent(payload: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'public-srv/consent/usage/accept/scope/user';
    return this.http.post(url, payload, { headers: this.getHeaders() });
  }

  userConsentActivity(sub: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'scopes-srv/scope/util/find/scope/user/consent/status/' + sub;
    return this.http.get(url, { headers: this.getHeaders() });
  }

  revokeConsent(sub: any, payload: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'scopes-srv/scope/util/scope/user/consent/status/update/' + sub;
    return this.http.put(url, payload, { headers: this.getHeaders() });
  }

  // Exist email check
  checkEmailAvailability(payload: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'public-srv/registration/user/exist/check';
    return this.http.post(url, payload, { headers: this.getHeaders() });
  }

  getWorkflowStatus(trackId: string): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'workflow-srv/usage/process/status/public/' + trackId;
    return this.http.get(url, { headers: this.getHeaders() });
  }

  validateWorkflowStatus(payload: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'workflow-srv/usage/initiate/v2/workflow';
    return this.http.post(url, payload,{ headers: this.getHeaders() });
  }

  workflowContinue(payload: any): Observable<any> {
    const headers = new HttpHeaders().set('Authorization', CookieStore.getBearerToken());
    const url = Defaultconfig.GetAuthBaseURL() + 'workflow-srv/usage/initiate/workflow/continue';
    return this.http.post(url, payload, { headers });
  }

  codeVerify(payload: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'verification-srv/accounts/user/verification';
    return this.http.post(url, payload,{ headers: this.getHeaders() });
  }

  // Get default password policy
  generatePasswordBypolicyName(name: any): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'password-policy-srv/password/policy_name/' + `${name}`;
    return this.http.get(url, { headers: this.getHeaders() });
  }

  // Get effective password policy for a user (resolves group-based policy)
  getEffectivePasswordPolicyForUser(sub: string): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'password-policy-srv/password/user/' + encodeURIComponent(sub) + '/effective';
    return this.http.get(url, { headers: this.getHeaders() });
  }
  // Verify ciba code 
  cibaVerify(cibaCode: string): Observable<any> {
    const url = Defaultconfig.GetAuthBaseURL() + 'ciba-srv/validate/' + `${cibaCode}`;
    return this.http.get(url, { headers: this.getHeaders() });
  }
}
